export default __webpack_public_path__ + "static/media/avatar-review-4.3458b619.svg";